/**
 * AbstractMessageBarData.ts
 */
export class AbstractMessageBarData {
    constructor() {
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.idleMessages = 10;
        this.idleStandardSpinMessages = 2;
        this.idleFreeSpinMessages = 2;
        this.chooseCellMessages = 2;
        this.chooseCellJokerMessages = 1;
        this.chooseCellSuperJokerMessages = 1;
    }
}
//# sourceMappingURL=AbstractMessageBarData.js.map